var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuteGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7 3.33921C14.83 3.01921 15.25 1.74921 14.57 0.0292093C14.57 0.0292093 13.52 -0.300791 11.13 1.32921C10.13 1.04921 9.06 1.00921 8 1.00921C6.94 1.00921 5.87 1.04921 4.87 1.32921C2.48 -0.310791 1.43 0.0292093 1.43 0.0292093C0.75 1.74921 1.17 3.01921 1.3 3.33921C0.49 4.20921 0 5.32921 0 6.68921C0 11.8392 3.33 12.9992 7.98 12.9992C12.63 12.9992 16 11.8392 16 6.68921C16 5.32921 15.51 4.20921 14.7 3.33921ZM7.99999 12.0192C4.69999 12.0192 2.01999 11.8692 2.01999 8.66921C2.01999 7.90921 2.39999 7.18921 3.03999 6.59921C4.10999 5.61921 5.93999 6.13921 7.99999 6.13921C10.07 6.13921 11.88 5.61921 12.96 6.59921C13.61 7.18921 13.98 7.89921 13.98 8.66921C13.98 11.8592 11.3 12.0192 7.99999 12.0192ZM5.49001 7.00921C4.83001 7.00921 4.29001 7.80921 4.29001 8.78921C4.29001 9.76921 4.83001 10.5792 5.49001 10.5792C6.15001 10.5792 6.69001 9.77921 6.69001 8.78921C6.69001 7.79921 6.15001 7.00921 5.49001 7.00921ZM10.51 7.00921C9.85 7.00921 9.31 7.79921 9.31 8.78921C9.31 9.77921 9.85 10.5792 10.51 10.5792C11.17 10.5792 11.71 9.77921 11.71 8.78921C11.71 7.79921 11.18 7.00921 10.51 7.00921Z",
    transform: "translate(0 128.051) scale(64)",
    fill: "#B0AFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuteGithub);
export default __webpack_public_path__ + "static/media/Cute-Github.bd7270ae827a8f7ed64c44e47ea459ff.svg";
export { ForwardRef as ReactComponent };